const _ = require('lodash');

function fileTypesFilter($filter) {
    const translateFilter = $filter('translate');

    return function (displayName, isFile, isSymLink) {
        if (angular.isUndefined(displayName)) return '-';

        const mostCommonFileTypes = [
            { type: 'unknownFile', description: 'common.fileType.unknownFile' },
            { type: '.Bin', description: 'vm.fileType.dir' },
            //Audio file formats by file extensions
            { type: '.aif', description: 'common.fileType.audio' },
            { type: '.cda', description: 'common.fileType.audio' },
            { type: '.mid', description: 'common.fileType.audio' },
            { type: '.midi', description: 'common.fileType.audio' },
            { type: '.mp3', description: 'common.fileType.audio' },
            { type: '.mpa', description: 'common.fileType.audio' },
            { type: '.ogg', description: 'common.fileType.audio' },
            { type: '.wav', description: 'common.fileType.audio' },
            { type: '.wma', description: 'common.fileType.audio' },
            { type: '.wpl', description: 'common.fileType.audio' },

            //Compressed file extensions
            { type: '.7z', description: 'common.fileType.compressed' },
            { type: '.arj', description: 'common.fileType.compressed' },
            { type: '.deb', description: 'common.fileType.compressed' },
            { type: '.pkg', description: 'common.fileType.compressed' },
            { type: '.rar', description: 'common.fileType.compressed' },
            { type: '.rpm', description: 'common.fileType.compressed' },
            { type: '.tar.gz', description: 'common.fileType.compressed' },
            { type: '.z', description: 'common.fileType.compressed' },
            { type: '.zip', description: 'common.fileType.compressed' },

            //Disc and media file extensions
            { type: '.bin', description: 'common.fileType.diskImage' },
            { type: '.dmg', description: 'common.fileType.diskImage' },
            { type: '.iso', description: 'common.fileType.diskImage' },
            { type: '.toast', description: 'common.fileType.diskImage' },
            { type: '.vcd', description: 'common.fileType.diskImage' },

            //Data and database file extensions
            { type: '.csv', description: 'common.fileType.database' },
            { type: '.dat', description: 'common.fileType.database' },
            { type: '.db', description: 'common.fileType.database' },
            { type: '.dbf', description: 'common.fileType.database' },
            { type: '.log', description: 'common.fileType.database' },
            { type: '.mdb', description: 'common.fileType.database' },
            { type: '.sav', description: 'common.fileType.database' },
            { type: '.sql', description: 'common.fileType.database' },
            { type: '.tar', description: 'common.fileType.database' },
            { type: '.xml', description: 'common.fileType.database' },
            { type: '.pdb', description: 'common.fileType.database' },

            //Executable file extensions
            { type: '.apk', description: 'common.fileType.executable' },
            { type: '.bat', description: 'common.fileType.executable' },
            { type: '.bin', description: 'common.fileType.executable' },
            { type: '.cgi', description: 'common.fileType.executable' },
            { type: '.pl', description: 'common.fileType.executable' },
            { type: '.com', description: 'common.fileType.executable' },
            { type: '.exe', description: 'common.fileType.executable' },
            { type: '.gadget', description: 'common.fileType.executable' },
            { type: '.jar', description: 'common.fileType.executable' },
            { type: '.py', description: 'common.fileType.executable' },
            { type: '.wsf', description: 'common.fileType.executable' },

            //Font file extensions
            { type: '.fnt', description: 'common.fileType.font' },
            { type: '.fon', description: 'common.fileType.font' },
            { type: '.otf', description: 'common.fileType.font' },
            { type: '.ttf', description: 'common.fileType.font' },
            { type: '.ttc', description: 'common.fileType.font' },

            //Image file formats by file extension
            { type: '.ai', description: 'common.fileType.image' },
            { type: '.bmp', description: 'common.fileType.image' },
            { type: '.gif', description: 'common.fileType.image' },
            { type: '.ico', description: 'common.fileType.image' },
            { type: '.jpeg', description: 'common.fileType.image' },
            { type: '.jpg', description: 'common.fileType.image' },
            { type: '.png', description: 'common.fileType.image' },
            { type: '.ps', description: 'common.fileType.image' },
            { type: '.psd', description: 'common.fileType.image' },
            { type: '.svg', description: 'common.fileType.image' },
            { type: '.tif', description: 'common.fileType.image' },
            { type: '.tiff', description: 'common.fileType.image' },

            //Internet related file extensions
            { type: '.asp', description: 'common.fileType.web' },
            { type: '.aspx', description: 'common.fileType.web' },
            { type: '.cer', description: 'common.fileType.web' },
            { type: '.cfm', description: 'common.fileType.web' },
            { type: '.cgi', description: 'common.fileType.web' },
            { type: '.pl', description: 'common.fileType.web' },
            { type: '.css', description: 'common.fileType.web' },
            { type: '.htm', description: 'common.fileType.web' },
            { type: '.html', description: 'common.fileType.web' },
            { type: '.js', description: 'common.fileType.web' },
            { type: '.jsp', description: 'common.fileType.web' },
            { type: '.part', description: 'common.fileType.web' },
            { type: '.php', description: 'common.fileType.web' },
            { type: '.py', description: 'common.fileType.web' },
            { type: '.rss', description: 'common.fileType.web' },
            { type: '.xhtml', description: 'common.fileType.web' },

            //Presentation file formats by file extension
            { type: '.key', description: 'common.fileType.presentation' },
            { type: '.odp', description: 'common.fileType.presentation' },
            { type: '.pps', description: 'common.fileType.presentation' },
            { type: '.ppt', description: 'common.fileType.presentation' },
            { type: '.pptx', description: 'common.fileType.presentation' },

            //Programming files by file extensions
            { type: '.c', description: 'common.fileType.source' },
            { type: '.class', description: 'common.fileType.source' },
            { type: '.cpp', description: 'common.fileType.source' },
            { type: '.cs', description: 'common.fileType.source' },
            { type: '.h', description: 'common.fileType.source' },
            { type: '.java', description: 'common.fileType.source' },
            { type: '.sh', description: 'common.fileType.source' },
            { type: '.swift', description: 'common.fileType.source' },
            { type: '.vb', description: 'common.fileType.source' },

            //Spreadsheet file formats by file extension
            { type: '.ods', description: 'common.fileType.spreadsheet' },
            { type: '.xlr', description: 'common.fileType.spreadsheet' },
            { type: '.xls', description: 'common.fileType.spreadsheet' },
            { type: '.xlsx', description: 'common.fileType.spreadsheet' },

            //System related file formats and file extensions
            { type: '.bak', description: 'common.fileType.system' },
            { type: '.cab', description: 'common.fileType.system' },
            { type: '.cfg', description: 'common.fileType.system' },
            { type: '.cpl', description: 'common.fileType.system' },
            { type: '.cur', description: 'common.fileType.system' },
            { type: '.dll', description: 'common.fileType.system' },
            { type: '.dmp', description: 'common.fileType.system' },
            { type: '.drv', description: 'common.fileType.system' },
            { type: '.icns', description: 'common.fileType.system' },
            { type: '.ico', description: 'common.fileType.system' },
            { type: '.ini', description: 'common.fileType.system' },
            { type: '.lnk', description: 'common.fileType.system' },
            { type: '.msi', description: 'common.fileType.system' },
            { type: '.sys', description: 'common.fileType.system' },
            { type: '.tmp', description: 'common.fileType.system' },

            //Video file formats by file extension
            { type: '.3g2', description: 'common.fileType.video' },
            { type: '.3gp', description: 'common.fileType.video' },
            { type: '.avi', description: 'common.fileType.video' },
            { type: '.flv', description: 'common.fileType.video' },
            { type: '.h264', description: 'common.fileType.video' },
            { type: '.m4v', description: 'common.fileType.video' },
            { type: '.mkv', description: 'common.fileType.video' },
            { type: '.mov', description: 'common.fileType.video' },
            { type: '.mp4', description: 'common.fileType.video' },
            { type: '.mpg', description: 'common.fileType.video' },
            { type: '.mpeg', description: 'common.fileType.video' },
            { type: '.rm', description: 'common.fileType.video' },
            { type: '.swf', description: 'common.fileType.video' },
            { type: '.vob', description: 'common.fileType.video' },
            { type: '.wmv', description: 'common.fileType.video' },

            //Word processor and text file formats by file extension
            { type: '.doc', description: 'common.fileType.text' },
            { type: '.docx', description: 'common.fileType.text' },
            { type: '.odt', description: 'common.fileType.text' },
            { type: '.pdf', description: 'common.fileType.text' },
            { type: '.rtf', description: 'common.fileType.text' },
            { type: '.tex', description: 'common.fileType.text' },
            { type: '.txt', description: 'common.fileType.text' },
            { type: '.wks', description: 'common.fileType.text' },
            { type: '.wps', description: 'common.fileType.text' },
            { type: '.wpd', description: 'common.fileType.text' }
        ];

        if (isSymLink) {
            return translateFilter('common.fileType.symLink');
        }
        else {
            if (isFile) {
                const splitDisplayNameArray = displayName.split('.');
                const temp = splitDisplayNameArray.length > 1 ? '.' + splitDisplayNameArray[splitDisplayNameArray.length - 1] : 'unknownFile';
                const filteredType = _.filter(mostCommonFileTypes, { type: temp });
                return filteredType.length ? translateFilter(filteredType[0].description) : translateFilter('common.fileType.file', { type: splitDisplayNameArray[splitDisplayNameArray.length - 1] });
            } else {
                return translateFilter('vm.fileType.dir');
            }
        }
    }
}

fileTypesFilter.$inject = ['$filter'];

module.exports = fileTypesFilter;


// WEBPACK FOOTER //
// ./src/azurebackup/filters/fileTypes.filter.js